import React, { useEffect } from "react";
import automationImage from "../Media/service4_process_automation.avif";
import bannerImage from "../Media/prozessdigitalisierung_service.jpg";
import integrationImage from "../Media/service4_process_integration.jpg";
import analyticsImage from "../Media/service4_process_analytics.jpg";
import Banner from '../Components/Banner.tsx';
import { useNavigate } from "react-router-dom";
import ProgressiveImageCustom from "../Components/ProgressiveImageCustom.tsx";

export default function ProcessDigitalization() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    const items = document.querySelectorAll(".services-list li");
    items.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  const handleInquiry = (featureName) => {
    navigate("/inquiry", { state: { preselectedTopic: featureName } });
  };

  return (
    <div className="service">
      <div className="page-content">
        <Banner
          image={bannerImage}
          textTop="Prozessdigitalisierung"
          textBottom="Effiziente, digitale Prozesse für Ihr Unternehmen"
          textColor="#ffffff"
        />
        <section className="textcontainer">
          <div className="spacer-div-30px"></div>
          <h1>Digitale Prozess&shy;transformation – strukturiert, effizient, zukunfts&shy;fähig</h1>
          <p>
            Die Digitalisierung von Geschäfts&shy;prozessen ist längst unternehmerische Pflicht. Insbesondere kleine und mittel&shy;ständische Unternehmen profitieren von durchgängig digitalisierten Abläufen, integrierten Datenflüssen und daten&shy;gestützter Steuerung. So entstehen belastbare Strukturen, die operative Effizienz, Transparenz und strategische Handlungs&shy;fähigkeit gleichermaßen stärken.
          </p>
          <p>
            Wir analysieren bestehende Prozess&shy;landschaften, identifizieren systemische Engpässe und implementieren skalierbare Lösungen, die sowohl technische als auch fachliche Anforderungen abdecken – individuell, effizient und zukunfts&shy;orientiert.
          </p>
          <hr />

          <ul className="services-list">
            <li>
              <div className="list-title">
                <strong>Prozess&shy;automatisierung & Ablaufs&shy;optimierung – strukturiert, nachvollziehbar, messbar</strong>
              </div>
              <ProgressiveImageCustom src={automationImage} />
              <div className="list-description">
                <p>
                  Manuelle Prozess&shy;brüche, redundante Arbeitsschritte und fehlende Transparenz bremsen Wert&shy;schöpfung. Wir gestalten standardisierte und adaptive Abläufe, die durch intelligente Steuerungs&shy;logik, ereignisgesteuerte Prozess&shy;ketten und technische Entkopplung zu robusten Geschäfts&shy;prozessen führen.
                </p>
                <p>
                  Ob Vertrags&shy;abwicklung, Onboarding oder interne Genehmigungs&shy;prozesse – wir analysieren Ist-Abläufe, modellieren optimierte Ziel&shy;prozesse und sorgen für deren digitale Umsetzung entlang klar definierter Prozess&shy;ziele.
                </p>
              </div>
            </li>

            <li>
            <div className="list-title">
  <strong>System&shy;integration & Daten&shy;strukturierung – Digitalisierte Prozesse vernetzen und stabilisieren</strong>
</div>
<ProgressiveImageCustom src={integrationImage} />
<div className="list-description">
  <p>
    Digitale Prozesse entfalten ihren Nutzen nur, wenn Systeme und Daten konsistent miteinander kommunizieren. Wir integrieren bestehende IT-Komponenten und externe Plattformen in eine stabile, interoperable Architektur. Dabei setzen wir auf standardisierte Schnittstellen, konsolidierte Daten&shy;modelle und automatisierte Synchronisation.
  </p>
  <p>
    Die systemübergreifende Integration sorgt für reibungslose digitale Prozess&shy;ketten, verhindert Informationsverluste und stärkt die Daten&shy;qualität als zentrale Grundlage für operative und strategische Entscheidungen.
  </p>
</div>

            </li>

            <li>
            <div className="list-title">
  <strong>Daten&shy;analytik & Entscheidungs&shy;unterstützung – Digitalisierte Prozesse messbar und steuerbar machen</strong>
</div>
<ProgressiveImageCustom src={analyticsImage} />
<div className="list-description">
  <p>
    Digitalisierte Prozesse erzeugen kontinuierlich Daten – wir machen sie auswertbar. Mit prozessnahen Analyse&shy;modellen, individuell definierten KPIs und intelligenten Visualisierungen schaffen wir Transparenz über Effizienz, Auslastung und Prozess&shy;qualität.
  </p>
  <p>
    Durch automatisiertes Monitoring, Abweichungs&shy;analysen und datenbasierte Entscheidungs&shy;hilfen erhalten Sie die Möglichkeit, digitale Prozess&shy;abläufe gezielt zu steuern, Eng&shy;pässe frühzeitig zu erkennen und Verbesserungs&shy;potenziale systematisch zu nutzen.
  </p>
</div>

            </li>
          </ul>
        </section>

        <button
          className="anfrage-btn not-on-grid"
          onClick={() => handleInquiry("Prozessdigitalisierung")}
        >
          Anfragen
        </button>
      </div>
    </div>
  );
}
